import React from 'react';
import { exportEventName } from '.';
import i18n from '../../../../utils/ChrI18n';
import ChrLink from '../../../generic/Utils/ChrLink';
import { MetricUId } from '../../Metrics/constants';
import { getMetricDataFromArray } from '../../Metrics/utils';
import MetricCard from '../MetricCard';
import PieChart from '../../Reports/templates/PieChart';
import WidgetBodyWrapper from '../WidgetBodyWrapper';
import getChartConfig from './utils';
import ChrComparison from '../../Reports/templates/ChrComparison';


const Body = (props) => {
  const { metrics, name } = props;
  const cardMetric = getMetricDataFromArray(metrics, MetricUId.PENDING_PROJECT_REQUESTS);
  const cardActionRequired = cardMetric.data.value > 0;
  const previousPeriod = cardMetric.data.previousPeriod;
  const totalProjectRequests = getMetricDataFromArray(metrics, MetricUId.TOTAL_PROJECT_REQUESTS);

  return (
    <WidgetBodyWrapper { ...props } additionalClassNames="custom-max-height-550-px" >
      <div className="d-flex flex-column">
        <MetricCard
          value={ cardMetric.data.value }
          title={ cardMetric.longName }
          result={ cardActionRequired && i18n.t("metrics.metric_card.take_action") }
          url={ cardMetric.url }
          alert={ cardMetric.data.alert }
          resultUrl={ cardActionRequired && cardMetric.url }
          eventDetails={ cardMetric.eventDetails }
          subtitle={ previousPeriod && <ChrComparison
            changeSentiment={ previousPeriod.insights.sentiment }
            changeValue={ previousPeriod.insights.changeValue }
            changeDirection={ previousPeriod.insights.direction }
            periodOne={ { dateRangeStr: previousPeriod.comparedAgainstPeriod.dateRangeStr, presetStr: previousPeriod.comparedAgainstPeriod.presetStr, value: cardMetric.data.value } }
            periodTwo={ { dateRangeStr: previousPeriod.timePeriod.dateRangeStr, presetStr: previousPeriod.timePeriod.presetStr, value: previousPeriod.value } }
          /> }
        />
        <div className='cui-widget-pie-chart pr-5'>
          <PieChart
            chartOptions={ getChartConfig({ metrics, name }) }
            configs={ { export: true, exportEventName } }
          />
        </div>
        {
          totalProjectRequests.expiryDetails &&
          <div className='cui-widget-info-bg d-flex flex-gap-10 p-3 border-radius-0-25 font-bold'>
            <i className="fa-regular fa-gear mt-1" />
            <span>{ totalProjectRequests.expiryDetails.infoText }</span>
            <ChrLink newTab href={ totalProjectRequests.expiryDetails.url }>({ i18n.t("display_string.Change") })</ChrLink>
          </div>
        }
      </div>
    </WidgetBodyWrapper>
  );
};

export default Body;